<div class="modal-header">
  <h4 class="modal-title">{{ "patientDetail.assessments" | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <div *ngIf="isLoading" class="d-flex justify-content-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ "loading" | translate }}...</span>
    </div>
  </div>

  <div *ngIf="hasError && !isLoading" class="text-center py-5 text-muted">
    <i class="fa-solid fa-triangle-exclamation fs-1 mb-3"></i>
    <p>{{ "patientDetail.noData" | translate }}</p>
  </div>

  <app-wound-assessment-detail
    *ngIf="!isLoading && !hasError"
    [wound]="wound"
  ></app-wound-assessment-detail>
</div>
